import { useEffect } from 'react';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import PageTooltip from './PageTooltip';

const RebateSummaryIndicator = ({ show, ids, tooltip }) => {
    return (
        show === true ? 
        <PageTooltip title={tooltip}>
            <ReportProblemIcon />
        </PageTooltip>
        : <></>
    ); 
}

export default RebateSummaryIndicator; 